/**
 * Typed version of Object.fromEntries()
 */
export const fromEntries = <
  T extends ReadonlyArray<readonly [PropertyKey, unknown]>,
>(
  entries: T,
) => Object.fromEntries(entries) as { [K in T[number][0]]: T[number][1] }

/*
 * Typed version of Object.entries()
 */
export const entries = <T extends object>(obj: T): [keyof T, T[keyof T]][] =>
  Object.entries(obj) as [keyof T, T[keyof T]][]
